import { useEffect, useState } from "react";
import { V2_ENDPOINT } from "../consts";
interface CategoriesApiResponse {
  code: number;
  message: string;
  data: string[];
  requestId: string;
}

/**
 * Hook to fetch all available tag categories from the API
 * Returns a sorted list of unique category names
 */
export function useTagCategories() {
  const [categories, setCategories] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  useEffect(() => {
    let mounted = true;
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const url = `${V2_ENDPOINT}/v1/tags/categories`;
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch categories: ${response.statusText}`);
        }
        const data: CategoriesApiResponse = await response.json();
        if (data.code !== 0) {
          throw new Error(`API error: ${data.message}`);
        }
        if (mounted) {
          setCategories(data.data || []);
          setError(null);
        }
      } catch (e) {
        const err = e instanceof Error ? e : new Error("Failed to load categories");
        console.error("Failed to load categories", err);
        if (mounted) {
          setError(err);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };
    fetchCategories();
    return () => {
      mounted = false;
    };
  }, []);
  return {
    categories,
    loading,
    error
  };
}